import React from "react";
import { IconProps } from "../icon";

export const AlignCenterIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M18 10H6m15-4H3m18 8H3m15 4H6"
    />
  </svg>
);
